import React from "react";
import Modal from "./Modal";

import { MODAL_CLOSE } from "src/constants/images";

const SellApprovalModal = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="heading">
      <h4 className="mb-2">Approve</h4>
      <p className="text my-3">
        Please approve to continue selling your GangstaBet.
      </p>
    </div>
    <div className="body">
      <button
        className="btn btn-outline-primary profile"
        onClick={() => onClick("approval")}
      >
        Get Approval
      </button>
    </div>
  </>
);

const BuyApprovalModal = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="heading">
      <h4 className="mb-2">Approval</h4>
      <p className="text my-3">
        You will need to provide permission to the marketplace to sell your NFTs
        at the price that you set.
      </p>
    </div>
    <div className="body">
      <button
        className="btn btn-outline-primary profile"
        onClick={() => onClick("approval")}
      >
        Next
      </button>
    </div>
  </>
);

const ApprovalModal = ({ isVisible, modalType, onClick }) => {
  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="disconnect-modal card px-3 py-3"
    >
      {modalType == "Sell" ? (
        <SellApprovalModal onClick={onClick} />
      ) : (
        <>
          <BuyApprovalModal onClick={onClick} />
        </>
      )}
    </Modal>
  );
};

export default ApprovalModal;
